import styled from "styled-components";

export const Styles = styled.div`
  &.detail-tracking {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  &.detail-tracking.is-editing .container-time_line-summary {
    padding-bottom: 60px;
  }

  &.detail-tracking--light {
    .detail-header-bar--manager {
      margin-bottom: 24px;
    }

    .detail-header-center .sub-title {
      color: rgba(0, 0, 0, 0.55);
    }

    .detail-header-bar--manager .detail-header-date {
      color: #434343;
      font-size: 16px;
      font-weight: 400;
    }

    .detail-header-bar--manager .detail-header-caption {
      color: rgba(0, 0, 0, 0.55);
    }

    .container-time_line-summary {
      align-items: flex-start;
    }

    .detail-timeline-block {
      background: #fafafa;
      border-radius: 12px;
      padding: 16px;
    }

    .container-item-field .left .line {
      background: #d9d9d9;
    }
  }

  .detail-header-bar {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
    padding: 0 4px;
    min-height: 72px;
  }

  .detail-header-bar--manager {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    min-height: auto;
    margin-bottom: 12px;
  }

  .detail-header-left {
    text-align: left;
    flex: 1;
    min-width: 0;
    padding-right: 8px;
  }

  .detail-header-date {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    color: var(--color-item);
  }

  .detail-header-caption {
    margin: 4px 0 0;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.75);
  }

  .detail-header-bar--manager .detail-header-actions {
    position: relative;
    top: auto;
    right: auto;
    flex-shrink: 0;
  }

  .detail-header-center {
    width: 100%;
    max-width: 100%;
    text-align: center;

    .title {
      font-size: 22px;
      font-weight: 700;
      margin: 0 0 4px;
      color: #f5f5f5;
    }

    .sub-title {
      margin: 0;
      font-size: 15px;
      color: rgba(255, 255, 255, 0.75);
    }
  }

  .detail-management-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    width: 100%;
  }

  .detail-management-select {
    min-width: 220px;
    max-width: 360px;
  }

  .detail-management-select.ant-select .ant-select-selector {
    background: var(--bg-field);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: var(--color-field);
  }

  .detail-header-actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  .button-header-back {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    background: #4759ff;
    color: #fff;

    &:hover {
      background: rgba(106, 141, 255, 0.35);
    }
  }

  .button-header-edit {
    padding: 6px 12px;
    min-height: 36px;
    font-size: 14px;
  }

  .week-choose-block {
    width: 100%;
  }

  .desktop & {
    .container-time_line-summary {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 32px;
      align-items: flex-start;
      width: 100%;
      margin: 0 auto;
    }

    .detail-timeline-form {
      order: 1;
      min-width: 0;
    }

    .detail-summary-column {
      order: 2;
      position: sticky;
      top: 16px;
    }

    .summary-item {
      border: 1px solid #0000000f;
    }
  }

  .mobile & {
    .container-time_line-summary {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .detail-summary-section {
      order: 1;
    }

    .detail-timeline-form {
      order: 2;
    }
  }

  .button-primary,
  .button-outline {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 12px 16px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 15px;
    border: none;
    cursor: pointer;
    width: 100%;
  }

  .button-primary {
    background: #4759ff;
    color: #fff;

    &:disabled {
      background: #00000040;
      cursor: not-allowed;
    }
  }

  .button-outline {
    border: 1px solid rgba(255, 255, 255, 0.35);
    color: #000000d9;
    background: #fff;

    .desktop & {
      border: 1px solid #000000d9;
      box-shadow: 0px 2px 0px 0px #0000000b;
    }
  }

  .container-footer {
    position: sticky;
    bottom: 0;
    z-index: 10;
    display: flex;
    padding: 12px 0 calc(12px + env(safe-area-inset-bottom, 0));
    gap: 10px;
    margin-top: auto;
    background: linear-gradient(180deg, transparent 0%, var(--bg-main) 16px);

    opacity: 0;
    transform: translateY(16px);
    pointer-events: none;
    transition: opacity 0.25s ease, transform 0.25s ease;
  }

  .container-footer.show {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

  .container-footer--manager {
    justify-content: flex-end;
    flex-wrap: nowrap;
    width: 100%;
    background: linear-gradient(180deg, transparent 0%, var(--bg-main) 16px);
    padding-top: 16px;

    .desktop & {
      padding: 16px 24px;
      background: #fafafa;
      border-radius: 16px;
    }
  }

  .container-footer--manager .button-primary,
  .container-footer--manager .button-outline {
    width: auto;
    min-width: 140px;
    max-width: 200px;
    flex: 0 0 auto;
  }

  .footer-btn-primary {
    order: 1;
  }

  .footer-btn-cancel {
    order: 2;
  }
`;
